const fr = {
  // Sidebar navigation
  nav_dashboard: 'Tableau de bord',
  nav_optimizer: 'Optimiseur',
  nav_builder: 'Constructeur',
  nav_compare: 'Comparer',
  nav_performance: 'Performance',
  nav_market: 'Données de marché',
  nav_stocks: 'Comparaison d\'actions',
  nav_planning_hub: 'Centre de planification',
  nav_concepts_library: 'Bibliothèque des concepts',
  nav_growth_forecast: 'Projection',
  nav_goal_planner: 'Planificateur d\'objectifs',
  nav_retirement: 'Retraite',
  nav_learning_center: 'Centre éducatif',
  nav_portfolio_optimization: 'Optimisation de portefeuille',
  nav_watchlist: 'Liste de suivi',
  nav_alerts: 'Alertes',
  nav_goals: 'Objectifs',
  nav_help: 'Aide',
  nav_contact: 'Contact',
  nav_mission: 'Mission',
  nav_mission_planning: 'Mission de planification',
  nav_admin: 'Admin',
  nav_sign_out: 'Se déconnecter',
  nav_sign_in: 'Se connecter',
  nav_register: 'S\'inscrire',
  nav_guest: 'Mode invité',
  nav_group_planning: 'Planification financière',
  nav_group_advanced_tools: 'Outils avancés',
  nav_group_monitoring: 'Suivi',
  nav_group_reference: 'Référence',
  nav_start_here: 'Commencer ici',
  nav_learn_accounts: 'Comptes',
  nav_learn_investing: 'Investir',
  nav_set_goal: 'Fixer un objectif',
  nav_forecast_growth: 'Projeter la croissance',
  nav_retirement_planning: 'Planifier la retraite',
  nav_planning_principles: 'Principes',
  nav_portfolio_analytics: 'Analyses de portefeuille',
  nav_asset_research: 'Recherche d\'actifs',
  nav_comparison_tools: 'Comparaisons',
  nav_stock_comparison: 'Comparer les actions',
  nav_portfolio_home: 'Accueil portefeuille',
  topbar_planning_hub: 'Centre de planification financière',
  topbar_portfolio_toolkit: 'Boîte à outils portefeuille',
  sidebar_tagline: 'Canadien. Indépendant. Centré sur vous.',

  // Common actions
  btn_save: 'Enregistrer',
  btn_cancel: 'Annuler',
  btn_create: 'Créer',
  btn_delete: 'Supprimer',
  btn_export: 'Exporter CSV',
  btn_generate: 'Générer le portefeuille',
  btn_add: 'Ajouter',
  btn_check: 'Vérifier',
  btn_new: 'Nouveau',
  btn_edit: 'Modifier',
  btn_share: 'Partager',
  btn_refresh: 'Actualiser',

  // Dashboard
  dash_title: 'Centre de commande',
  dash_welcome: 'Bon retour',
  dash_kpi_portfolio_value: 'Valeur projetée',
  dash_kpi_gain_loss: 'Gain/Perte projeté',
  dash_kpi_portfolios: 'Portefeuilles actifs',
  dash_kpi_sp500: 'Rendement S&P 500',
  dash_section_performance: 'Performance',
  dash_section_holdings: 'Principales positions',
  dash_section_activity: 'Activité récente',
  dash_section_saved: 'Portefeuilles sauvegardés',
  dash_no_portfolios: 'Aucun portefeuille pour l\'instant.',

  // Portfolio Generator
  pg_title: 'Générateur de portefeuille',
  pg_subtitle: 'Construisez un portefeuille diversifié selon votre profil de risque',
  pg_section_params: 'Paramètres du portefeuille',
  pg_label_persona: 'Profil d\'investisseur',
  pg_label_investment: 'Montant d\'investissement',
  pg_label_min_holdings: 'Min. positions',
  pg_label_max_holdings: 'Max. positions',
  pg_label_max_position: 'Position max. (%)',
  pg_label_max_sector: 'Secteur max. (%)',
  pg_label_include_etfs: 'Inclure les ETFs',
  pg_label_include_bonds: 'Inclure les obligations',
  pg_results_title: 'Résultats du portefeuille',
  pg_asset_dist: 'Répartition par type d\'actif',
  pg_sector_dist: 'Répartition sectorielle',
  pg_metrics_title: 'Indicateurs du portefeuille',

  // Market Data
  md_title: 'Base de données de marché',
  md_subtitle: 'Parcourez et filtrez les actions avec des indicateurs fondamentaux et quantitatifs',
  md_search_placeholder: 'Rechercher un ticker ou une société...',
  md_filter_exchange: 'Bourse',
  md_filter_sector: 'Secteur',
  md_all_exchanges: 'Toutes les bourses',
  md_all_sectors: 'Tous les secteurs',
  md_research_title: 'Recherchez un actif a la fois',
  md_research_subtitle: 'Recherchez d\'abord, puis ouvrez les fondamentaux, l\'historique des prix et les details de valorisation avancee seulement lorsque c\'est utile.',
  md_price_data_as_of: 'Donnees de prix au',
  md_tickers_latest_date: 'titres a la date la plus recente',
  md_browse_stocks_title: 'Parcourir les actions',
  md_browse_stocks_subtitle: 'Trouvez le titre que vous voulez comprendre',
  md_showing_count: 'Affichage de {{shown}} sur {{total}} actions',
  md_search_asset_begin: 'Recherchez un actif pour commencer',
  md_choose_from_count: 'Choisissez parmi {{count}} actions dans votre base de donnees, puis ouvrez les details progressivement.',

  // Watchlist
  wl_title: 'Liste de suivi',
  wl_subtitle: 'Suivez vos actions favorites et surveillez leur performance.',
  wl_add_stock: 'Ajouter une action',
  wl_no_stocks: 'Aucune action dans votre liste de suivi.',

  // Goals
  goals_title: 'Objectifs & Cibles',
  goals_new: 'Nouvel objectif',
  goals_explainer_title: 'Que sont les objectifs\u00a0?',
  goals_no_goals: 'Aucun objectif pour l\'instant.',

  // Alerts
  alerts_title: 'Alertes de prix',
  alerts_new: 'Nouvelle alerte',
  alerts_no_alerts: 'Aucune alerte définie.',

  // Performance
  perf_title: 'Tableau de bord de performance',

  // Compare
  cmp_title: 'Comparaison de portefeuilles',
  cmp_subtitle: 'Sélectionnez des portefeuilles à comparer côte à côte',

  // Help
  help_title: 'Aide & FAQ',
  help_subtitle: 'Découvrez la plateforme, les concepts financiers et comment tirer le meilleur parti de vos analyses.',

  // Auth
  auth_login_title: 'Se connecter',
  auth_register_title: 'Créer un compte',
  auth_email: 'Adresse e-mail',
  auth_password: 'Mot de passe',
  auth_confirm_password: 'Confirmer le mot de passe',
  auth_or_guest: 'ou continuer en tant qu\'invité',

  // Status
  status_loading: 'Chargement...',
  status_saving: 'Enregistrement...',
  status_saved: 'Enregistré.',
  status_error: 'Une erreur s\'est produite.',
  status_no_data: 'Aucune donnée disponible.',

  // App shell
  app_subtitle: 'Planification éducative et modélisation de scénarios pour les ménages canadiens.',
  app_planning_subtitle: 'Guides orientés débutants pour les comptes enregistrés, les objectifs et les scénarios de retraite.',
  app_optimization_subtitle: 'Outils d\'optimisation de portefeuille simplifiés avec moins d\'encombrement et des parcours plus clairs.',
  workspace_open_optimization: 'Ouvrir l\'optimisation de portefeuille',
  workspace_open_planning: 'Ouvrir le centre de planification financière',
  workspace_planning_title: 'Espace planification financière',
  workspace_optimization_title: 'Espace optimisation de portefeuille',
  workspace_planning_subtitle: 'Outils simples pour comptes enregistrés, objectifs et retraite.',
  workspace_optimization_subtitle: 'Analytique ciblée pour construire, optimiser et suivre les portefeuilles.',
  api_notice_health_degraded: 'Certaines fonctions de données en direct sont temporairement ralenties. Attendez environ 30 à 90 secondes pendant la reconnexion puis réessayez.',
  api_notice_rate_limit: 'Nous traitons un volume élevé de requêtes. Attendez environ 30 à 60 secondes puis réessayez.',
  api_notice_timeout: 'Le service de données en direct prend plus de temps que d\'habitude. Attendez environ 30 à 90 secondes puis réessayez — votre session et vos portefeuilles restent sécurisés.',
  api_notice_reconnect: 'Nous avons du mal à joindre le service d\'analyse pour le moment. Attendez environ 30 à 90 secondes pendant la reconnexion puis réessayez.',
  api_notice_busy: 'Le moteur d\'analyse est temporairement occupé. Attendez environ 30 à 90 secondes puis réessayez votre demande.',
};

export default fr;
